export default "__VITE_ASSET__PcjI0Zyj__"